import styled from 'styled-components';
import { DESKTOP_WIDTH, TABLET_WIDTH } from '../../globalUtils';

import { Area } from '../index.style';

export const Container = styled.div`
    display: flex;
    justify-content: center;
    background-color: #e9ecf1;
    width: 100%;
    padding: 89px 0 135px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        padding: 31px 0 69px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        padding: 21px 0 47px;
    }
`;

export const StickyArea = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export { Area };